export const showDialog = () => (dispatch, getState) => {

  return dispatch({
    type: "showDialog"
  })
}

export const hideDialog = () => (dispatch, getState) => {

  return dispatch({
    type: "hideDialog"
  })
}


// WEBPACK FOOTER //
// ./src/Components/DialogComponent/actions/index.js